var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrbit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "101px",
    height: "117px",
    viewBox: "0 0 101 117",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "loader") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "loader",
    transform: "translate(0.129410, -0.017037)",
    fill: "#6363AC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.0506909,72.7783139 C90.4411383,99.3159777 62.7593499,114.660244 36.2216861,107.050691 C9.6840223,99.4411383 -5.66024355,71.7593499 1.9493091,45.2216861 C9.55886174,18.6840223 37.2406501,3.33975645 63.7783139,10.9493091 C90.3159777,18.5588617 105.660244,46.2406501 98.0506909,72.7783139 Z M93.2456218,71.4004825 C100.094219,47.5165851 86.2843799,22.6029756 62.4004825,15.7543782 C38.5165851,8.90578081 13.6029756,22.7156201 6.75437819,46.5995175 C-0.094219192,70.4834149 13.7156201,95.3970244 37.5995175,102.245622 C61.4834149,109.094219 86.3970244,95.2843799 93.2456218,71.4004825 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    transform: "translate(50.000000, 59.000000) rotate(-90.000000) translate(-50.000000, -59.000000) ",
    cx: 50,
    cy: 59,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 50.5,
    cy: 12.5,
    r: 12.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 49.3705905,
    cy: 104.517037,
    r: 12.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbit);
export default __webpack_public_path__ + "static/media/orbit.372f89a3e168f2e24e6df0e9f99c87a8.svg";
export { ForwardRef as ReactComponent };